import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
//import { HttpModule } from '@angular/http';
import { APP_BASE_HREF, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';

import { SidebarModule } from './sidebar/sidebar.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule } from './shared/navbar/navbar.module';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AppRoutes } from './app.routing';
import { HttpClientModule } from '@angular/common/http';
import { AgmCoreModule } from '@agm/core';

import { LoginComponent } from './auth/login/login.component';

import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { InputTextModule } from 'primeng/inputtext';
import { PanelModule } from 'primeng/panel';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ChipModule } from 'primeng/chip';
import { CalendarModule } from 'primeng/calendar';
import { InputMaskModule } from 'primeng/inputmask';
import { StepsModule } from 'primeng/steps';
import { SliderModule } from 'primeng/slider';

import { TabViewModule } from 'primeng/tabview';
import { ProgressBarModule } from 'primeng/progressbar';
import { TagModule } from 'primeng/tag';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DividerModule } from 'primeng/divider';
import { GalleriaModule } from 'primeng/galleria';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputNumberModule } from 'primeng/inputnumber';

// Usados por la pantalla del botón de pánico. TabViewModule ya estaba importado
// más arriba pero nunca había entrado al arreglo de imports, así que <p-tabView>
// no funcionaba en ningún lado.
import { MultiSelectModule } from 'primeng/multiselect';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FieldsetModule } from 'primeng/fieldset';
import { MessageModule } from 'primeng/message';
import { TooltipModule } from 'primeng/tooltip';
import { FileUploadModule } from 'primeng/fileupload';
import { BadgeModule } from 'primeng/badge';
import { AvatarModule } from 'primeng/avatar';
import { HomeComponent } from './home/home.component';
import { BooleanoPipe } from './pipes/booleano.pipe';
import { ForgotpasswordComponent } from './auth/forgotpassword/forgotpassword.component';
import { RestablecepasswordComponent } from './auth/restablecepassword/restablecepassword.component';
import { CambiapasswordComponent } from './auth/cambiapassword/cambiapassword.component';
import { ClientesComponent } from './maestros/clientes/clientes.component';
import { GuardiasComponent } from './maestros//guardias/guardias.component';
import { InstalacionesComponent } from './maestros/instalaciones/instalaciones.component';
import { AsistenciaComponent } from './reportes/asistencia/asistencia.component';
import { GuardiasenturnoComponent } from './reportes/guardiasenturno/guardiasenturno.component';
import { ReportesupervisorComponent } from './reportes/reportesupervisor/reportesupervisor.component';
import { AsistenciaindividualComponent } from './reportes/asistenciaindividual/asistenciaindividual.component';
import { ControlusuariosComponent } from './accesos/controlusuarios/controlusuarios.component';
import { RegistrosdeaccesoComponent } from './accesos/registrosdeacceso/registrosdeacceso.component';
import { SupervisoresComponent } from './maestros/supervisores/supervisores.component';
import { SoporteComponent } from './maestros/soporte/soporte.component';
import { EventosComponent } from './eventos/eventos.component';

import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { UsuariosComponent } from './maestros/usuarios/usuarios.component';
import { FacturacionComponent } from './facturacion/facturacion.component';
import { NgxPrintModule } from 'ngx-print';
import { RegistrosaccesosComponent } from './accesos/registrosaccesos/registrosaccesos.component';
import { EmpresasComponent } from './maestros/empresas/empresas.component';
import { PrefacturaComponent } from './prefactura/prefactura.component';
import { AvancesmarketingComponent } from './marketing/avancesmarketing/avancesmarketing.component';
import { VersionesappsComponent } from './maestros/versionesapps/versionesapps.component';
import { McpadopcionComponent } from './maestros/mcpadopcion/mcpadopcion.component';
import { PromocionesComponent } from './maestros/promociones/promociones.component';
import { BotonpanicoComponent } from './maestros/botonpanico/botonpanico.component';

@NgModule({
    imports: [
        NgxPrintModule,
        NgxQRCodeModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        RouterModule.forRoot(AppRoutes, {
            useHash: true
        }),
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBfEddosLxcRY2VD5Na3gMlSo5H0qbUj1M'// 'AIzaSyA3wPXgHoWPyTb1JCb6XPnbSPd4piWrAac'
        }),
        NgbModule,
        // HttpModule,
        SidebarModule,
        NavbarModule,
        FooterModule,
        CardModule,
        ConfirmPopupModule,
        InputTextModule,
        ButtonModule,
        ToastModule,
        PanelModule,
        DialogModule,
        ConfirmDialogModule,
        TableModule,
        ToggleButtonModule,
        AutoCompleteModule,
        CheckboxModule,
        DropdownModule,
        CalendarModule,
        InputMaskModule,
        StepsModule,
        SliderModule,
        TagModule,
        InputNumberModule,
        InputTextareaModule,
        FileUploadModule,
        BadgeModule,
        GalleriaModule,
        RadioButtonModule,
        ChipModule,
        AvatarModule,
        TabViewModule,
        MultiSelectModule,
        InputSwitchModule,
        FieldsetModule,
        MessageModule,
        TooltipModule
    ],
    declarations: [
        AppComponent,
        AdminLayoutComponent,
        AuthLayoutComponent,
        LoginComponent,

        HomeComponent,
        BooleanoPipe,
        ForgotpasswordComponent,
        RestablecepasswordComponent,
        CambiapasswordComponent,
        ClientesComponent,
        GuardiasComponent,
        InstalacionesComponent,
        AsistenciaComponent,
        GuardiasenturnoComponent,
        ReportesupervisorComponent,
        AsistenciaindividualComponent,
        ControlusuariosComponent,
        RegistrosdeaccesoComponent,
        SupervisoresComponent,
        SoporteComponent,
        EventosComponent,
        UsuariosComponent,
        FacturacionComponent,
        RegistrosaccesosComponent,
        EmpresasComponent,
        PrefacturaComponent,
        AvancesmarketingComponent,
        VersionesappsComponent,
        McpadopcionComponent,
        PromocionesComponent,
        BotonpanicoComponent,

    ],
    providers: [
        DatePipe,
        ConfirmationService,
        MessageService,
    ],
    bootstrap: [AppComponent]
})

export class AppModule { }